var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHideLabels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,20c-0.4-0.4-0.8-0.8-1.3-1.3c-0.2-0.2-0.3-0.2-0.5-0.1c-2.7,1.3-5.7,0.8-7.8-1.4c-0.7-0.7-1.1-1.6-1.7-2.4 c-0.2-0.2-0.1-0.4,0-0.7c0.6-1.2,1.3-2.2,2.4-3.1c-0.5-0.5-0.9-0.9-1.4-1.3C8,9.4,8.3,9.2,8.6,8.8c3.4,3.4,6.8,6.9,10.2,10.3 C18.6,19.4,18.3,19.7,18,20z M15,16.9c-0.2-0.2-0.4-0.3-0.6-0.5c-0.2-0.2-0.3-0.2-0.6-0.2c-1.4,0.4-2.6-0.9-2.2-2.2 c0-0.1,0.1-0.3,0-0.4c-0.2-0.3-0.5-0.5-0.7-0.8c-0.9,1.2-0.7,2.9,0.5,3.9C12.3,17.6,14,17.8,15,16.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3,9.9c2.1-0.6,3.9-0.3,5.7,0.8c1.3,0.9,2.3,2.1,2.9,3.5c0,0.1,0.1,0.3,0,0.4c-0.4,0.9-0.9,1.7-1.5,2.4 c-0.7-0.7-1.3-1.3-2-2c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-1.9-1.4-3.3-3.2-3.2c-0.1,0-0.3,0-0.4-0.1C12.3,10.9,11.8,10.4,11.3,9.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,12.7H1.5V5.1h16.9v4.8c0.5,0.4,1.1,0.9,1.5,1.5V3.6H0v10.6h5.2c0-0.2,0.1-0.5,0.2-0.8C5.5,13.2,5.7,12.9,5.8,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7,9.6l3-2.8l1.8,1.8l0.4-0.1c2.4-0.7,4.6-0.5,6.1,0.5V6.3H2.7v5.1h3.7c0,0,0.2-0.3,0.6-0.5L5.7,9.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideLabels);
export default __webpack_public_path__ + "static/media/hide-labels.c5b330b5.svg";
export { ForwardRef as ReactComponent };